import { useMutation } from "@tanstack/react-query";
import { Link, useNavigate, useSearch } from "@tanstack/react-router";
import type { ReactElement } from "react";
import { ContentHeader } from "@cx/ui";
import { errorMessage } from "../../errors";
import { useSession } from "../../session";

/**
 * "Tela de consentimento" do Mercado Livre de testes (só no ambiente de testes). Autorizar gera o `code` e segue para
 * o mesmo retorno do OAuth real.
 */
export function MlSandboxConsentPage(): ReactElement {
  const { api } = useSession();
  const { state } = useSearch({ from: "/integracoes/mercado-livre/sandbox" });
  const navigate = useNavigate();
  const authorize = useMutation({
    mutationFn: () =>
      api<{ code: string; state: string }>("/marketplaces/mercadolivre/sandbox/authorize", {
        method: "POST",
        body: JSON.stringify({ state }),
      }),
    onSuccess: (r) => {
      void navigate({
        to: "/integracoes/mercado-livre/retorno",
        search: { code: r.code, state: r.state },
        replace: true,
      });
    },
  });
  return (
    <>
      <ContentHeader
        title="Mercado Livre de testes"
        breadcrumb={["Preferências", "Integrações", "Mercado Livre"]}
      />
      <div className="box card p-3" style={{ maxWidth: 560 }}>
        <p>
          O <strong>CX ERP</strong> quer acessar sua conta de vendedor de testes: anúncios, pedidos e estoque.
          Nenhuma conta real do Mercado Livre é usada.
        </p>
        {authorize.isError && <div className="alert alert-danger py-2">{errorMessage(authorize.error)}</div>}
        <div className="d-flex gap-2">
          <button
            type="button"
            className="btn btn-primary"
            disabled={!state || authorize.isPending}
            onClick={() => authorize.mutate()}
          >
            Autorizar
          </button>
          <Link
            className="btn btn-outline-secondary"
            to="/integracoes/mercado-livre/retorno"
            search={{ error: "access_denied" }}
            replace
          >
            Recusar
          </Link>
        </div>
      </div>
    </>
  );
}
